import React, { Component } from 'react';
import Answer from './Answer';

class PanelAnswers extends Component {
  render() {
    const answers = this.props.answers.map((answer, i) => 
      <Answer 
          key={i}
          id={i}
          answered={this.props.answered}
          answer={answer}
          onClick={() => this.props.onClick(i)}/>
    );

    return (
        <div className="quiz__panel quiz__panel--answers">
          {answers}
        </div>
    );
  }
}

export default PanelAnswers;


// WEBPACK FOOTER //
// ./src/components/PanelAnswers.js